// Contracts — javelin manager Web Push (2026-06-11, low-budget alerts).
// Worker side: apps/api/src/javelin/push.ts (all endpoints javelin_pm-gated
// except pushConfig which is any-authed-user). Client side: apps/internal
// javelin island features/push. Events list is the source of truth for
// both the worker filter and the UI toggles; today only 'budget_low' —
// a moderator's running budget crossed strictly below $500 on a capture.
import { z } from 'zod';

export const JAV_PUSH_EVENTS = ['budget_low', 's3_deleted'] as const;

export const JavPushEventSchema = z.enum(JAV_PUSH_EVENTS);
export type JavPushEvent = z.infer<typeof JavPushEventSchema>;

export const JavPushConfigResSchema = z.looseObject({
  vapidPublicKey: z.string(),
});

export const JavPushStatusReqSchema = z.object({
  endpoint: z.string().trim().min(1),
});

export const JavPushStatusResSchema = z.looseObject({
  subscribed: z.boolean(),
  events: z.array(JavPushEventSchema),
});

export const JavPushSubscribeReqSchema = z.object({
  endpoint: z.string().trim().min(1),
  p256dh: z.string().trim().min(1),
  auth: z.string().trim().min(1),
  events: z.array(JavPushEventSchema).default([]),
});

export const JavPushPrefsReqSchema = z.object({
  endpoint: z.string().trim().min(1),
  events: z.array(JavPushEventSchema).default([]),
});

export const JavPushUnsubscribeReqSchema = z.object({
  endpoint: z.string().trim().min(1),
});

export const JavPushOkResSchema = z.looseObject({
  ok: z.boolean(),
  events: z.array(JavPushEventSchema).default([]),
});

export const JavPushTestResSchema = z.looseObject({
  ok: z.boolean(),
  sent: z.number(),
});

export type JavPushConfigRes = z.infer<typeof JavPushConfigResSchema>;
export type JavPushStatusRes = z.infer<typeof JavPushStatusResSchema>;
export type JavPushOkRes = z.infer<typeof JavPushOkResSchema>;
export type JavPushTestRes = z.infer<typeof JavPushTestResSchema>;
